<template>
  <div>
    <div class="-mob-share-ui-button -mob-share-open">
      <svg class="icon navBtn share" aria-hidden="true">
        <use xlink:href="#icon-fenxiang"></use>
      </svg>
    </div>
    <div class="-mob-share-ui" style="display: none">
      <ul class="-mob-share-list">
        <li class="-mob-share-weibo"><p>新浪微博</p></li>
        <li class="-mob-share-qq"><p>QQ好友</p></li>
        <li class="-mob-share-weixin"><p>微信</p></li>
      </ul>
      <div class="-mob-share-close">取消</div>
    </div>
    <div class="-mob-share-ui-bg"></div>
  </div>

</template>

<script>
  export default {
    name: "shareM",
    methods:{
    },
    mounted() {
    }
  }
</script>

<style scoped>
  .-mob-share-close {
    height: .8rem !important;
    line-height: 1.5 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    font-size: .4rem !important;
    color: white !important;
    background: #191919 !important;
  }

  .-mob-share-list {
    top: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    margin-top: 5rem !important;
  }

  .-mob-share-ui ul.-mob-share-list li {
    width: 1.1rem !important;
    height: 1.1rem !important;
    font-size: .38rem;

  }

  .share {
    color: #191919;
    width: .45rem;
    height: .45rem;
  }

  .-mob-share-ui-button {
    background: transparent !important;
    border-radius: 10%;

  }
</style>



// WEBPACK FOOTER //
// src/components/shareM.vue